import React, { Component } from "react";
import styled, { css } from "react-emotion";
import { HasPermission } from "components";
import { withRedux } from "helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactGA from "react-ga";
ReactGA.initialize(
  process.env.NODE_ENV === "prod" ? "UA-108363979-2" : "UA-108363979-3"
);

const Container = styled("div")`
  position: relative;
  min-width: 185px;
  /* margin-right: 10px; */
  /* margin-right: 70px; */
  /* height: 100vh; */
  background: #f5f5f5;
  /* background: red; */
  padding: 1em;
  color: #1f3747;
  display: flex;
  flex-direction: column;
  transition: width 1s;
`;

const iconStyle = css`
  font-size: 1.2em;
  min-width: 1.5em;
  cursor: pointer;
  margin-top: 10px;
  margin-bottom: 10px;
  color: #5f6368;
`;

const listItemStyle = css`
  font-size: 0.9375rem;
  letter-spacing: 0.2px;
  margin: auto 10px;
`;

const AlignRight = styled("div")`
  text-align: right;
`;

const AlignLeft = styled("div")`
  text-align: left;
  margin-top: 64px;
  position: fixed;
  /* width: 100%; */
  margin-left: 0px;
  overflow-y: auto;
  overflow-x: hidden;
  top: 0;
  bottom: 0;
  width: 185px;
`;

const NavItem = styled("div")`
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  -webkit-transition-property: color;
  transition-property: color;
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;

  ::before {
    content: "";
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgb(137, 210, 211);
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transform-origin: 0 50%;
    transform-origin: 0 50%;
    -webkit-transition-property: transform;
    transition-property: transform;
    -webkit-transition-duration: 0.5s;
    transition-duration: 0.5s;
    -webkit-transition-timing-function: ease-out;
    transition-timing-function: ease-out;
  }
  &:hover,
  &:focus,
  &:active {
    color: white;
  }
  &:hover:before,
  &:focus:before,
  &:active:before {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
    -webkit-transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);
    transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);
  }
  position: relative;
  cursor: ${(props) => (props.hover ? "pointer" : "default")};
  width: 220px;
  padding: 0px 10px;
  vertical-align: top;
  display: flex;

  /* border-radius: 0 16px 16px 0; */

  /* &:hover {
    background-color: ${(props) =>
    props.hover ? "rgb(137, 210, 211)" : "inherit"};
  } */
`;

const StaticNavItem = styled("div")`
  position: relative;
  cursor: ${(props) => (props.hover ? "pointer" : "default")};
  width: 220px;
  padding: 0px 10px;
  vertical-align: top;
  display: flex;
`;

class LeftNav extends Component {
  state = {
    expandNav: true,
    displayText: true,
    appEditor: [],
    deal: [],
    reward: [],
  };

  setDisplay = (display) => {
    this.props.actions.setDisplay(display);
  };

  toggleExpand = () => {
    let { expandNav, displayText } = this.state;
    expandNav = !expandNav;
    displayText = !displayText;
    this.setState({ expandNav });

    if (expandNav) {
      setTimeout(() => {
        this.setState({ displayText });
      }, 700);
    } else {
      this.setState({ displayText });
    }
  };

  aboutUsTemplateId = () => {
    const {
      activeApp: {
        view: { templates },
      },
    } = this.props;

    const aboutUs = templates.find((el) => el.type === "aboutUs");
    return aboutUs.id;
  };

  isAtHome = () => {
    return !this.props.activeTemplate;
  };

  clearTemplate = () => {
    const { activeApp } = this.props;
    this.props.actions.setTemplate(activeApp.id, null);
  };

  render() {
    const { expandNav, displayText } = this.state;

    const appEditor = [];
    let deal = {};
    let reward = {};

    this.props.activeApp.view.templates.map((template) => {
      let { background, components, type, ...navInfo } = template;

      switch (template.type) {
        case "deals":
          return (deal = navInfo);
        case "rewards":
          return (reward = navInfo);
        default:
          return appEditor.push(navInfo);
      }
    });

    // const { activeApp } = this.props;
    // const { templateId } = this.props.platformInfo.display;
    // if (templateId) this.props.actions.setTemplate(activeApp.id, null);

    const navItems = [
      {
        icon: "edit",
        text: "App Editor",
        templateId: null,
        view: null,
        display: displayText,
        pathName: "home",
        permission: 2,
      },
      {
        icon: "map-signs",
        text: "App Information",
        templateId: this.aboutUsTemplateId(),
        view: null,
        display: displayText,
        pathName: "aboutUs",
        permission: 2,
      },
      {
        icon: "tag",
        text: "Manage Deals",
        templateId: deal.id,
        view: null,
        display: displayText,
        hidden: !deal.id,
        pathName: "deals",
        permission: 2,
      },
      {
        icon: "trophy",
        text: "Rewards",
        templateId: reward.id,
        view: null,
        display: displayText,
        hidden: !reward.id,
        pathName: "rewards",
        permission: 2,
      },
      {
        icon: "comment-alt",
        text: "Push Notification",
        templateId: null,
        view: "NotificationCenter",
        display: displayText,
        pathName: "notificationCenter",
        permission: 3,
      },
      {
        icon: "chart-line",
        text: "Analytics",
        templateId: null,
        view: "Analytics",
        display: displayText,
        pathName: "analytics",
        permission: 1,
      },

      {
        text: "App Overview",
        templateId: null,
        view: "Analytics",
        display: displayText,
        pathName: "analytics",
        permission: 1,
      },
      {
        text: "App Downloads",
        templateId: null,
        view: "Users",
        display: displayText,
        pathName: "customers",
        permission: 1,
      },

      {
        icon: "file-invoice",
        text: "Invoices",
        templateId: null,
        view: "Invoices",
        display: displayText,
        pathName: "notificationCenter",
        permission: 1,
      },

      {
        icon: "money-check-alt",
        text: "Store",
        templateId: null,
        view: "Store",
        display: displayText,
        pathName: "storeSettings",
        permission: 1,
      },
      {
        text: "Order History",
        templateId: null,
        view: "PurchaseHistory",
        display: displayText,
        pathName: "analytics",
        permission: 1,
      },
      {
        text: "Coupons",
        templateId: null,
        view: "Coupons",
        display: displayText,
        pathName: "coupons",
        permission: 1,
      },
      {
        text: "Settings",
        templateId: null,
        view: "StoreSettings",
        display: displayText,
        pathName: "storeSettings",
        permission: 1,
      },
      {
        icon: "user-shield",
        text: "Permissions",
        templateId: null,
        view: "Permissions",
        display: displayText,
        pathName: "permissions",
        permission: 0,
      },
      // {
      //   icon: "user-plus",
      //   text: "Invite User",
      //   templateId: null,
      //   view: "InviteUser",
      //   display: displayText,
      //   pathName: "inviteUser",
      //   permission: 0,
      // },
      {
        icon: "play",
        text: "Video Tutorials",
        templateId: null,
        view: "Tutorials",
        display: displayText,
        pathName: "tutorials",
        permission: 0,
      },
    ];

    return (
      <Container
        expandNav={expandNav}
        height={window.innerHeight}
        // height="4000px"
        style={{
          padding: "0px",
          borderRight: "1px solid rgb(100 121 143 / 12%)",
        }}
      >
        <AlignLeft>
          {navItems.map((item, idx) => {
            const {
              icon,
              text,
              templateId,
              view,
              display,
              hidden,
              pathName,
              permission,
            } = item;

            if (hidden) return null;
            if (view === "Store" || text === "Analytics") {
              return (
                <StaticNavItem>
                  <FontAwesomeIcon className={iconStyle} icon={icon} />
                  <span
                    style={{
                      margin: "auto 10px",
                    }}
                    className={listItemStyle}
                  >
                    {text}
                  </span>
                </StaticNavItem>
              );
            }

            if (
              view === "PurchaseHistory" ||
              view === "Coupons" ||
              view === "StoreSettings" ||
              text === "App Overview" ||
              view === "Users"
            ) {
              return (
                <HasPermission key={idx} permission={permission}>
                  <NavItem
                    key={idx}
                    hover={true}
                    style={{ padding: "5px" }}
                    onClick={() => {
                      const appId = this.props.activeApp.id;
                      const shippoToken = this.props.activeApp.shippoToken;
                      const userId = this.props.platformInfo.status.user.id;
                      const activeApp = this.props.activeApp;
                      if (text === "App Overview") {
                        try {
                          const currentUser =
                            this.props.platformInfo.status.user.id;
                          const currentApp = this.props.activeApp.id;
                          ReactGA.pageview(
                            `${window.location.pathname}/${pathName}?currenUser=${currentUser}&app=${currentApp}`
                          );
                        } catch (e) {
                          console.log(e);
                        }
                        this.setDisplay({
                          templateId,
                          view,
                        });
                      }

                      if (view === "PurchaseHistory") {
                        let detailsSubmitted = null;
                        let requiresMoreInfo = null;
                        if (activeApp.stripeExpressAccountInfo) {
                          const {
                            stripeExpressAccountInfo: {
                              stripeExpressDetailsSubmitted,
                              stripeExpressRequiresMoreInfo,
                            },
                          } = activeApp;
                          detailsSubmitted = stripeExpressDetailsSubmitted;
                          requiresMoreInfo = stripeExpressRequiresMoreInfo;
                        }
                        this.props.history.push(`/orders`, {
                          appId,
                          userId,
                          stripeExpressDetailsSubmitted: detailsSubmitted,
                          stripeExpressRequiresMoreInfo: requiresMoreInfo,
                          shippoToken,
                        });
                      }
                      if (view === "Users") {
                        this.props.history.push(`/${appId}/customers`);
                      }
                      if (view === "Coupons") {
                        this.props.history.push(`/coupons`, {
                          appId,
                        });
                      }
                      if (view === "StoreSettings") {
                        this.props.history.push(`/store-settings`, {
                          appId,
                        });
                      }
                    }}
                  >
                    {display && (
                      <span
                        style={{
                          margin: "5px 10px",
                          paddingLeft: "50px",
                        }}
                        className={listItemStyle}
                      >
                        {text}
                      </span>
                    )}
                  </NavItem>
                </HasPermission>
              );
            }

            if (view === "Invoices") {
              const appId = this.props.activeApp.id;
              return (
                <HasPermission key={idx} permission={permission}>
                  <NavItem
                    key={idx}
                    hover={true}
                    onClick={() => {
                      this.props.history.push(`/app/${appId}/admin/invoices`);
                    }}
                  >
                    <FontAwesomeIcon className={iconStyle} icon={icon} />
                    {display && (
                      <span
                        style={{
                          margin: "auto 10px",
                        }}
                        className={listItemStyle}
                      >
                        {text}
                      </span>
                    )}
                  </NavItem>
                </HasPermission>
              );
            }

            if (view === "Tutorials") {
              return (
                <HasPermission key={idx} permission={permission}>
                  <NavItem
                    key={idx}
                    hover={true}
                    onClick={() => {
                      this.props.history.push(`/user-tutorials`);
                    }}
                  >
                    <FontAwesomeIcon className={iconStyle} icon={icon} />
                    {display && (
                      <span
                        style={{
                          margin: "auto 10px",
                        }}
                        className={listItemStyle}
                      >
                        {text}
                      </span>
                    )}
                  </NavItem>
                </HasPermission>
              );
            }

            return (
              <HasPermission key={idx} permission={permission}>
                <NavItem
                  key={idx}
                  hover={true}
                  onClick={() => {
                    try {
                      const currentUser =
                        this.props.platformInfo.status.user.id;
                      const currentApp = this.props.activeApp.id;
                      ReactGA.pageview(
                        `${window.location.pathname}/${pathName}?currenUser=${currentUser}&app=${currentApp}`
                      );
                    } catch (e) {
                      console.log(e);
                    }
                    this.setDisplay({
                      templateId,
                      view,
                    });
                  }}
                >
                  <FontAwesomeIcon className={iconStyle} icon={icon} />
                  {display && (
                    <span
                      style={{
                        margin: "auto 10px",
                      }}
                      className={listItemStyle}
                    >
                      {text}
                    </span>
                  )}
                </NavItem>
              </HasPermission>
            );
          })}
        </AlignLeft>
      </Container>
    );
  }
}

export default withRedux(LeftNav);
